import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-replication",
  "use": "app-icon-replication-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 16\" id=\"app-icon-replication\"><path d=\"M1 3h11a1 1 0 011 1v11a1 1 0 01-1 1H1a1 1 0 01-1-1V4a1 1 0 011-1zm1 2v9h9V5H2zm13.083 6.337a1 1 0 01-1-1V2h-8.35a1 1 0 110-2h9.35a1 1 0 011 1v9.337a1 1 0 01-1 1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol